import * as React from "react";
const SvgBug24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "black",
        viewBox: "0 0 24 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10.5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm4.344 2.04a3.5 3.5 0 1 0-5.689 0c-1.378.544-2.58 1.473-3.518 2.66l-.19-.094-2-1-.894-.448-.895 1.79.895.446 2 1 .011.006c-.471.951-.8 1.998-.957 3.1H.5v2h3.012c.055 1.172.303 2.298.711 3.333L2.4 19.7l-.8.6 1.2 1.6.8-.6 1.556-1.167C6.685 22.458 9.146 24 12 24s5.315-1.542 6.844-3.867L20.4 21.3l.8.6 1.2-1.6-.8-.6-1.823-1.367A10.42 10.42 0 0 0 20.488 15H23.5v-2h-3.107a10.268 10.268 0 0 0-.957-3.1l.011-.006 2-1 .895-.447-.895-1.789-.894.448-2 1-.19.094c-.937-1.187-2.14-2.116-3.519-2.66ZM5.5 14.5c0-3.848 2.464-6.86 5.5-7.41v14.82c-3.036-.55-5.5-3.562-5.5-7.41Zm13 0c0 3.848-2.464 6.86-5.5 7.41V7.09c3.036.55 5.5 3.562 5.5 7.41Z",
      clipRule: "evenodd"
    })
  );
export default SvgBug24Px;
